export default "/SHELL.570bbb90f34abc9cbd6e9c2491e5b336.svg";